import React from "react"
import Typography from '@mui/material/Typography';
//import ArrowRightIcon from '@mui/icons-material/ArrowRight';

export const TextDia = () => {

return(
<div>
    
<Typography variant="h6" >
<br />


<br /> <br /> 


<Typography component="span" variant="h5" sx={{fontWeight: '600'}}>Associated Genes: </Typography>
<br /><br />
'TNFA', 'MTNR1B', 'KCNQ1', 'SLC16A13', 'JAZF1', 'IRS1', 'TMEM154', 'TCF7L2', 'PSMD6', 'ZMPSTE24', 'SLC19A2', 'CP', 'GLIS3', 'EIF2B1', 'EIF2S3', 'AKT2', 'RFX6', 'CNOT1', 'PTF1A', 'APPL1', 'ZBTB20', 
 'ZBTB20', 'GATA4', 'GATA6', 'GCK', 'HNF4A', 'AIRE', 'ZFP57', 'IL2RA', 'INS', 'INSR', 'PDX1', 'KCNJ11', 'MAFA', 'NEUROD1', 'NKX2-2', 'CISD2', 'NEUROG3', 'PAX4', 'PAX6', 'PCBD1', 'FOXP3', 'IER3IP1', 
 'PIK3R1', 'POLD1', 'SLC29A3', 'DNAJC3', 'BLK', 'SLC2A2', 'STAT1', 'STAT3', 'ABCC8', 'HNF1A', 'HNF1B', 'WFS1', 'ALMS1', 'DCAF17', 'ITCH', 'KLF11', 'PPP1R15B', 'DYRK1B', 'TRMT10A', 'EIF2AK3', 'LRBA'  ]


 
<br /><br /> 
 
</Typography>

</div>
)
}